import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LocalStrings from "@language";
import FourZeroFourPNG from "../../assets/image/404.png";

const PageNotFound = (props) => {
  return (
    <div className="Four-Zero-Four">
      <img
        alt=""
        src={FourZeroFourPNG}
        className="mr-4 mb-4"
        style={{ height: 150, width: 150 }}
      />
      <div className="no-content-tex">{LocalStrings.kNoPageDesc}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PageNotFound);
